"use strict";
exports.__esModule = true;
exports.isValidName = void 0;
/**
 * For names, the below special characters will cause an error when sending to Socure:
 * ^±!@£$%&*_+¡€#¢§¶•ªº«<>?\/:;|=
 */
function hasValidCharacters(name) {
    var validCharactersRegex = new RegExp(/^[a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u01FF]+(?:[ ' -][a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u01FF]+)*'?$/u);
    return validCharactersRegex.test(name);
}
/**
 * Checks to see if a name is composed of just space characters
 */
function isNameNotEmpty(name) {
    return !!name.trim();
}
/**
 * Checks that a name have no invalid characters in them that would cause errors, and
 * that the name is not composed of just whitespace.
 */
var isValidName = function (name) {
    return hasValidCharacters(name) && isNameNotEmpty(name);
};
exports.isValidName = isValidName;
